var _defs, _path, _rect, _path2, _polygon, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailRejected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #475c89;\n      }\n\n      .cls-2 {\n        fill: #d1d6e0;\n      }\n\n      .cls-3 {\n        fill: #c1272d;\n      }\n\n      .cls-4 {\n        fill: #5a74b8;\n      }\n\n      .cls-5 {\n        fill: #b0bcd1;\n      }\n\n      .cls-6 {\n        fill: #506a00;\n      }\n\n      .cls-7 {\n        fill: #dadfea;\n      }\n\n      .cls-8 {\n        fill: #bec3cc;\n      }\n\n      .cls-9 {\n        opacity: .3;\n      }\n\n      .cls-10 {\n        fill: #ededed;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m161.61,500.24h403.77v225.79c0,10.27-8.34,18.61-18.61,18.61H180.22c-10.27,0-18.61-8.34-18.61-18.61v-225.79h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 167,
    y: 358,
    width: 371,
    height: 253,
    rx: 9.37,
    ry: 9.37,
    transform: "translate(-70.01 59.67) rotate(-8.8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m809.65,682.51c-.09.28-.18.57-.27.85-11.46,36.1-35.71,65.91-65.19,81.64-7.54,4.02-15.42,7.12-23.52,9.17-44.92,11.37-91.25-8.05-137.13-6.05-51.6,2.24-99.3,31.16-148.51,49.83-49.2,18.68-107.35,25.58-148.68-11.34-24.94-22.27-39.59-56.96-52.21-90.94-19.27-51.86-36.04-106-39.78-162.55-2.08-31.59.83-66.14,18.54-89.75,11.65-15.52,28.19-24.29,44.21-32.6,27.64-14.37,56.02-28.94,86.12-30.97,43.27-2.9,85.87,20.45,128.98,15.15,27.81-3.43,53.53-18.52,78.67-33.12,13.92-8.09,28.11-16.17,42.74-22.15,11.78-4.83,23.86-8.3,36.31-9.33,22.4-1.83,60.98,7.38,69.33,36.8,4.21,14.86.92,31.11,7.09,46.92,1.45,3.73,3.09,7.35,4.88,10.87,4.78,9.46,10.65,18.19,17.04,26.16.99,1.25,2,2.47,3.02,3.68,19.93,23.6,44.02,42.36,61.04,69.01,24.78,38.8,31.55,92.98,17.32,138.72Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "665.68 515.24 665.38 515.41 665.38 515.24 665.68 515.24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m551.11,412.23v295.54c0,3.61-3.19,6.54-7.11,6.54H185.22c-3.93,0-7.11-2.93-7.11-6.54v-295.54c0-57.74-13.51-84.68-25.87-97.25-4.16-4.23-.96-10.97,5.24-10.97h354.61c1,0,2,.19,2.91.57,7.21,3.05,36.11,20.73,36.11,107.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m803.84,320.34l43.87-43.87c3.46-3.46,3.46-9.07,0-12.53s-9.07-3.46-12.53,0l-43.87,43.87-43.87-43.87c-3.46-3.46-9.07-3.46-12.53,0s-3.46,9.07,0,12.53l43.87,43.87-43.87,43.87c-3.46,3.46-3.46,9.07,0,12.53,3.46,3.46,9.07,3.46,12.53,0l43.87-43.87,43.87,43.87c3.46,3.46,9.07,3.46,12.53,0,3.46-3.46,3.46-9.07,0-12.53l-43.87-43.87Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 221,
    y: 502,
    width: 285,
    height: 15,
    rx: 7.18,
    ry: 7.18
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 221,
    y: 456,
    width: 285,
    height: 15,
    rx: 7.18,
    ry: 7.18
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 221,
    y: 548,
    width: 285,
    height: 15,
    rx: 7.18,
    ry: 7.18
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 221,
    y: 594,
    width: 285,
    height: 15,
    rx: 7.18,
    ry: 7.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m565.38,500.41v224.78c0,10.74-8.71,19.45-19.45,19.45H181.05c-10.74,0-19.45-8.71-19.45-19.45v-224.96h.3l187.18,113.3c9.04,5.47,20.37,5.47,29.41,0l186.88-113.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m238.13,694c41.41-22.89,83.84-44.38,126.21-65.45h0c.74-.37,1.59-.39,2.34-.06,16.65,7.3,34.81,15.4,51.38,22.92,28,12.72,57.29,26.3,84.8,40-28.69-11.01-58.51-23.41-86.8-35.45-16.75-7.1-35.05-15.08-51.6-22.35,0,0,2.36-.05,2.36-.05-42.49,20.85-85.34,41.47-128.69,60.44h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m769.02,683.83h-241.14c-3.6,0-6.27-3.22-5.51-6.63l25.31-112.81h201.54l25.31,112.81c.76,3.41-1.91,6.63-5.51,6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m809.38,683.36c-11.46,36.1-35.71,65.91-65.19,81.64h-259.26c-11.4,0-20.64-9.23-20.64-20.64v-40.36c0-11.39,9.24-20.64,20.64-20.64h324.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "749.22 564.39 547.67 564.39 574.48 444.94 722.4 444.94 749.22 564.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m722.41,444.94h-147.92l25.93-115.59c.28-1.24,1-2.32,1.97-3.09.39-.31.83-.56,1.31-.77.68-.28,1.43-.43,2.22-.43h85.04c.8,0,1.55.15,2.22.43,1.63.68,2.89,2.09,3.29,3.85l25.93,115.59Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 348.25,
    y: 193.74,
    width: 205.49,
    height: 263.52,
    rx: 14.64,
    ry: 14.64,
    transform: "translate(207.45 -174.54) rotate(28.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m458.8,326.33l42.57-10.13c3.36-.8,5.43-4.17,4.63-7.53s-4.17-5.43-7.53-4.63l-42.57,10.13-10.13-42.57c-.8-3.36-4.17-5.43-7.53-4.63-3.36.8-5.43,4.17-4.63,7.53l10.13,42.57-42.57,10.13c-3.36.8-5.43,4.17-4.63,7.53.8,3.36,4.17,5.43,7.53,4.63l42.57-10.13,10.13,42.57c.8,3.36,4.17,5.43,7.53,4.63,3.36-.8,5.43-4.17,4.63-7.53l-10.13-42.57Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRejected);
export default __webpack_public_path__ + "static/media/email-rejected.fc5d87a1a948e5d7218762ec0198b8aa.svg";
export { ForwardRef as ReactComponent };